import React from "react";
import { ReportCard } from "./ReportCard";
import "./Reports.css";
import UserActivityReports from "../../../assets/Icons/SuperAdmin _ Reports/user activity report.svg";
import OrgUserStatistics from "../../../assets/Icons/SuperAdmin _ Reports/Organization User Statistics.svg";
import OrgBookSummaryIcon from "../../../assets/Icons/SuperAdmin _ Reports/Organization Book Summary.svg";

const reportData = [
  {
    _id: 1,
    icon: UserActivityReports,
    label: "Employee Activity",
    link: "employee-activity",
    description:
      "Employee report for the selected company with role, org books completed, points earned and redeemed, balance, time trials, and last login. Active means at least one org or company book completed in the last two months.",
  },
  {
    _id: 2,
    icon: OrgUserStatistics,
    label: "Company Wise Breakdown",
    link: "company-wise-breakdown",
    description:
      "Totals for the selected company: employees, active and inactive users, points earned and redeemed, balance, and admin counts. Active means at least one org or company book completed in the last two months.",
  },
  {
    _id: 3,
    icon: OrgBookSummaryIcon,
    label: "Organization Book Summary",
    link: "org-book-summary",
    description:
      "Published organisation books in sequence with eligible, completed, ongoing, and locked user counts for the selected company.",
  },
];

export const Reports = () => {
  return (
    <div className="container">
      <div className="reports">
        {reportData.map((elm) => (
          <ReportCard key={elm._id} base="/admin/reports" data={elm} />
        ))}
      </div>
    </div>
  );
};
